import { IQuotePaymentTermCodeState } from '@/store/quote-payment-term-code';
import { IQuotePaymentTermCodeMutations } from './mutations.types';
import { IQuotePaymentTermCodeData } from '@/models';

export const mutations: IQuotePaymentTermCodeMutations = {
  SET_QUOTE_PAYMENT_TERM_CODES(
    state: IQuotePaymentTermCodeState,
    payload: IQuotePaymentTermCodeData[]
  ): void {
    state.quotePaymentTermCodes = payload;
  },

  ADD_QUOTE_PAYMENT_TERM_CODE(
    state: IQuotePaymentTermCodeState,
    payload: IQuotePaymentTermCodeData
  ): void {
    state.quotePaymentTermCodes.push(payload);
  },

  UPDATE_QUOTE_PAYMENT_TERM_CODE(
    state: IQuotePaymentTermCodeState,
    payload: IQuotePaymentTermCodeData
  ): void {
    const index = state.quotePaymentTermCodes.findIndex(
      (quotePaymenTermCode: IQuotePaymentTermCodeData) =>
        quotePaymenTermCode.id === payload.id
    );

    state.quotePaymentTermCodes.splice(index, 1, payload);
  }
};
